import { Stack } from '@mui/material';
import { VoiceCallModel } from 'flow-schema';

import { api } from 'common';

import {
  BlockValueTemplateField,
  BlockValueTemplateFieldArea,
} from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

const { VoiceCallModelDescriptions } = api.FlowDefinition;

export function UpdateAssistantFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.assistantId"
        label="Assistant Id"
        helperText="Enter the reference to the Assistant - e.g. `{{assistant.data.assistantId}}`"
        placeholder="e.g. {{assistant.data.assistantId}}"
      />
      <BlockSelectField
        label="Model"
        fieldName="config.model"
        required
        options={Object.values(VoiceCallModel)
          .filter((model) => model !== VoiceCallModel.notable_gpt_4o)
          .map((model) => ({
            label: VoiceCallModelDescriptions[model],
            value: model,
          }))}
      />
      <BlockValueTemplateFieldArea
        fieldName="config.prompt"
        label="Assistant Prompt"
        required={true}
      />
      <BlockValueTemplateFieldArea
        fieldName="config.firstMessage"
        label="First Assistant Message"
      />
    </Stack>
  );
}
